import rhinoCore from 'rhino/src/core/core.module';

import * as rnPusher from './pusher.service';

export default angular.module('rhino.components.pusher', [
  rhinoCore,
])
  .factory(rnPusher.name, rnPusher.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/pusher/pusher.module.js